import {
  FC,
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from 'react'

import { buildObjects, buildStrings } from 'utils'
import { config } from 'config'
import { Article, Strings } from 'models'
import { GlobalStyle } from 'styles/global'
import { Loader } from 'components/loader'

type DataContextType = {
  articles: Article[]
  strings: Strings
  appLocale: typeof config.locale
}

const DataContext = createContext<DataContextType | null>(null)
const spreadsheetId = '1OsTP9EIwpIa6K2liDnUi2MFpvomEyPKXHDmckKM0WOs'
const apiKey = 'AIzaSyDliBdIaszCPY0qUrpbRZZyNpBIlzpAous'

export const DataProvider: FC<{
  children?: ReactNode | ReactNode[]
}> = ({ children }) => {
  const params = new URLSearchParams(window.location.search)
  const appLocale = (params.get('lang') ||
    config.locale) as typeof config.locale
  const [articles, setArticles] = useState<Article[]>([])
  const [strings, setStrings] = useState<Strings | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    Promise.all([
      fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/Articles?alt=json&key=${apiKey}`
      ).then((res) => res.json()),
      fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/Strings?alt=json&key=${apiKey}`
      ).then((res) => res.json()),
    ])
      .then(([rawArticles, rawStrings]) => {
        setArticles(buildObjects<Article>(rawArticles))
        setStrings(buildStrings(rawStrings))
      })
      .catch((err) => {
        console.log('error', err)
      })
      .finally(() => setIsLoading(false))
  }, [])

  return isLoading ? (
    <>
      <GlobalStyle />
      <Loader />
    </>
  ) : (
    <DataContext.Provider
      value={{
        strings: strings as Strings,
        articles,
        appLocale,
      }}
    >
      {children}
    </DataContext.Provider>
  )
}

export const useDataContext = () => {
  const context = useContext(DataContext)
  return context as DataContextType
}
